import { render, staticRenderFns } from "./WorkflowFolder.vue?vue&type=template&id=3fdb5a42&scoped=true"
import script from "./WorkflowFolder.vue?vue&type=script&lang=js"
export * from "./WorkflowFolder.vue?vue&type=script&lang=js"
import style0 from "./WorkflowFolder.vue?vue&type=style&index=0&id=3fdb5a42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb5a42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSkeletonLoader,VSpacer,VTextField})
